import React from "react";

function AffiliateProgram() {
  return <div>AffiliateProgram</div>;
}

export default AffiliateProgram;
